import PropTypes from "prop-types";
import React from "react";

import { ButtonSizes } from "../constants";
import { createClassNameString } from "../utils";
import { getAutomationDataAttr } from "../../utils/automationUtils";

import "./styles.scss";

export const Button = ({
  buttonSize,
  buttonType,
  children,
  className,
  disabled,
  name,
  onClick,
  testId,
  type,
  ...props
}) => {
  const classNameArray = ["apti-CL apti-Button", className, buttonType];

  if (buttonSize !== ButtonSizes.normal) {
    classNameArray.push(buttonSize);
  }

  return (
    <button
      className={createClassNameString(classNameArray)}
      disabled={disabled}
      name={name}
      onClick={onClick}
      type={type}
      {...getAutomationDataAttr(testId)}
      {...props}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  buttonType: PropTypes.oneOf([
    "primary",
    "primary-v2",
    "primary-v3",
    "primary-outline",
    "primary-v2-outline",
    "secondary",
    "secondary-outline",
    "label",
  ]),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]).isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["small", "normal"]),
  testId: PropTypes.string,
  type: PropTypes.oneOf(["button", "reset", "submit"]),
};

Button.defaultProps = {
  buttonType: undefined,
  children: <></>,
  className: undefined,
  disabled: false,
  name: "",
  onClick: () => {},
  size: "normal",
  testId: undefined,
  type: "button",
};
